import { Components, Theme } from '@mui/material';

const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.fontSizes.sm,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '100%',
      margin: theme.spacing(
        theme.spacingSizes.xs,
        theme.spacingSizes.xxs,
        0,
        theme.spacingSizes.xxs,
      ),
    }),
  },
};

export default MuiFormHelperText;
